import React, { useContext, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { Button, Typography } from '@mui/material';
import { SetStateAction, useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Chip,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';

import ChecklistIcon from '@mui/icons-material/Checklist';
import LinkIcon from '@mui/icons-material/Link';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { DraftFunction, useImmer } from 'use-immer';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { PaginationContext } from '../../../contexts/pagination-context';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import ResponsiveOrdersListing, { relevant_fields } from './orders-listing';
import DeliveryBatchDialog from '../../delivery-company-components/delivery-tasks/delivery-task-dialog';
import CreateOrderForm from '../../delivery-company-components/orders/create-order-form/create-order-form';
import PickupTaskDialog from '../../delivery-company-components/pickup-tasks/pickup-task-dialog';
import BulkAction from '../bulk-action/bulk-action';
import CreateEntityDrawer from '../create-entity-drawer/create-entity-drawer';
import DoubleDateOrdersFilter from '../double-date-orders-filter/double-date-orders-filter';
import { generateDateFilterQueryParam } from '../double-date-orders-filter/utils';
import {
  DoubleDateMode,
  DoubleDateWithMode,
} from '../double-date-picker/double-date-picker.interfaces';
import FilterBar from '../filter-bar/filter-bar';
import { buildQueryParams } from '../filter-bar/filter-bar.utils';
import { OrdersFilterKeys } from '../filter-bar/keys-config';
import { IFilterOption } from '../filter-bar/types';
import { SortingByColumnState } from '../generic-table/utils';
import SearchBar from '../search-bar/search-bar';
import FrozenOrdersButtonWithDialog from './frozen-orders-dialog';
import { AcUnit, ExpandMore, ManageSearch } from '@mui/icons-material';
import { IconWithText } from '../styles/components';
import { UserType } from '../../../enums/users';
import UnfreezeOrderDialog from './unfreeze-order-dialog';
import { QuickFilterScope } from '../../../enums/quick-filters';
import NewFeatureChip from '../new-feature-chip';
import { IQuickFilter } from '../../../interfaces/common/quick-filters';
import { ApplyQuickFilter } from '../apply-quick-filters-manager/apply-quick-filters-manager';

function FrozenOrders() {
  const [ordersList, setOrdersList] = useState<OrderType[]>([]);
  const [ordersCount, setOrdersCount] = useState(0);
  const [sorting, setSorting] = useState<SortingByColumnState>({
    column: 'creation_date',
    order: 'decreasing',
  });

  const [showingPickupTask, setShowingPickupTask] = useState<string | null>(
    null
  );
  const [showingDeliveryBatch, setShowingDeliveryBatch] = useState<
    string | null
  >(null);

  console.log(sorting);
  const [dateFilter, setDateFilter] = useState<DoubleDateWithMode>({
    startDate: null,
    endDate: null,
    mode: DoubleDateMode.CREATION_DATE,
  });
  const { color } = useContext(OrgSettingsContext);

  const [requestedUnfreeze, setRequestedUnfreeze] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [selectedOrders, updateSelectedOrders] = useImmer<
    Map<string, OrderType>
  >(new Map());

  const resetSelectionState = () => {
    updateSelectedOrders((selectedOrders) => {
      selectedOrders.clear();
    });
  };

  const { user, config } = useContext(AuthContext);

  const { paginationConfig, setPaginationConfig } =
    useContext(PaginationContext);

  console.log('pagination config = ', paginationConfig);
  const totalSelected = selectedOrders.size;

  const searchOptions = ['Order_Id', 'Ref_Number'];

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: paginationConfig.rowsPerPage,
    searchColumn: 'Order_Id',
    searchValue: '',
    searchOperation: 'equals',
  });

  const [filters, setFilters] = useState<IFilterOption[]>([]);

  useEffect(() => {
    let response: any;
    const getData = async () => {
      let endpoint = `${API_ENDPOINT}/api/v1/orders/?page=${controller.page + 1}&page_size=${controller.rowsPerPage}&fields=${relevant_fields.join(',')}`;

      if (controller.searchColumn !== '' && controller.searchValue !== '') {
        endpoint += `&${controller.searchColumn.toLowerCase()}__${controller.searchOperation}=${encodeURIComponent(controller.searchValue)}`;
      }

      const filterQueryParams = buildQueryParams(filters);
      endpoint += `${filterQueryParams}`;
      endpoint += `&${generateDateFilterQueryParam(dateFilter)}`;
      endpoint += `&sort_by_${sorting.order}=${encodeURIComponent(sorting.column)}`;
      endpoint += `&include_frozen=true&frozen=true`;

      console.log(endpoint);
      try {
        response = await axios.get<{ count: number; results: OrderType[] }>(
          endpoint,
          config
        );

        setOrdersList(response.data.results);
        setOrdersCount(response.data.count);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    setIsLoading(true);
    getData();
    console.log(response);
  }, [controller, dateFilter, filters, sorting]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPaginationConfig({ ...paginationConfig, rowsPerPage: newRowsPerPage });
    setController({
      ...controller,
      rowsPerPage: newRowsPerPage,
      page: 0,
    });
  };

  const searchQueryAction = (
    column: string,
    value: string,
    operation: string
  ) => {
    setController({
      ...controller,
      page: 0,
      searchColumn: column,
      searchValue: value,
      searchOperation: operation,
    });
  };

  const resetPaginationControls = () => {
    setController({
      ...controller,
      page: 0,
    });
  };
  
  const filterQueryAction = (filters: IFilterOption[]) => {
    resetPaginationControls();
    setFilters(filters);
    resetSelectionState();
  };

  const dateFilterAction = (dateFilterValue: DoubleDateWithMode) => {
    resetPaginationControls();
    setDateFilter(dateFilterValue);
  };
  
  return (
    <div className="content-container">
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box>
            <Typography
            variant="h5"
            component="h5"
            sx={{ textAlign: 'center', mt: 1, mb: 1 }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <ManageSearch fontSize="large" color="primary" />
              <span>
                <b>Search and Filter Controls</b>
              </span>
            </div>
          </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <SearchBar
            searchOptions={searchOptions}
            searchQueryAction={searchQueryAction}
          />
          <br />

          <DoubleDateOrdersFilter
            dateFilterAction={dateFilterAction}
            modes={[DoubleDateMode.CREATION_DATE]}
          />
          <br />
          <FilterBar
            filterQueryAction={filterQueryAction}
            currentlySelectedFilters={filters}
            filterKeys={OrdersFilterKeys(
              user?.type === UserType.MERCHANT ? 'merchant' : 'organisation'
            )}
            quickFiltersScope={QuickFilterScope.ORDER}
          />
        </AccordionDetails>
      </Accordion>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 10,
          marginLeft: 10,
        }}
      >
        <Chip
          icon={<ChecklistIcon />}
          color="primary"
          label={`Selected ${totalSelected}/${ordersCount}`}
          variant={
            totalSelected === ordersCount && totalSelected > 0
              ? 'filled'
              : 'outlined'
          }
        />

        <Button
          variant="contained"
          disabled={selectedOrders.size == 0}
          onClick={() => setRequestedUnfreeze(true)}
        >
          Unfreeze
        </Button>
      </div>

      <ResponsiveOrdersListing
        ordersList={ordersList}
        selectedOrders={selectedOrders}
        updateSelectedOrders={updateSelectedOrders}
        isLoading={isLoading}
        sorting={sorting}
        setSorting={setSorting}
        sourceView={"frozen-orders-listing"}
        applyQuickFilter={(quickFilter: IQuickFilter | null) => ApplyQuickFilter(quickFilter, filters, setFilters)}
      />
      <TablePagination
        component="div"
        onPageChange={handlePageChange}
        page={controller.page}
        count={ordersCount}
        rowsPerPage={controller.rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 250, 500, 1000]}
        labelRowsPerPage=""
        style={{ overflow: 'visible' }}
      />
      {showingPickupTask && (
        <PickupTaskDialog
          onClose={() => setShowingPickupTask(null)}
          taskID={showingPickupTask}
        />
      )}
      {showingDeliveryBatch && (
        <DeliveryBatchDialog
          onClose={() => setShowingDeliveryBatch(null)}
          taskID={showingDeliveryBatch}
        />
      )}
      {requestedUnfreeze && selectedOrders.size > 0 && (
        <UnfreezeOrderDialog
          onClose={() => setRequestedUnfreeze(false)}
          onSuccess={() => {
            setOrdersCount(ordersCount - selectedOrders.size);
            setOrdersList(
              ordersList.filter((order) => !selectedOrders.has(order.id))
            );
            resetSelectionState();
          }}
          orders={Array.from(selectedOrders.values())}
        />
      )}
    </div>
  );
}

export default FrozenOrders;
